import { Badge } from "@/components/ui/badge";

interface FilterHeaderProps {
  selectedServiceType: string;
}

export const FilterHeader = ({ selectedServiceType }: FilterHeaderProps) => {
  return (
    <div className="space-y-4">
      <h2 className="text-3xl font-bold text-[#174996]">Find Your Perfect Contractor</h2>
      <p className="text-lg text-muted-foreground">
        Browse our curated list of trusted local contractors. Each professional is verified and rated by homeowners in your area.
      </p>
      {selectedServiceType !== 'all' && (
        <div className="flex items-center gap-2">
          <span className="text-sm text-muted-foreground">Active filter:</span>
          <Badge variant="secondary" className="capitalize">
            {selectedServiceType}
          </Badge>
        </div>
      )}
    </div>
  );
};